import { render, staticRenderFns } from "./LiveCase.vue?vue&type=template&id=0de93ad6"
import script from "./LiveCase.vue?vue&type=script&lang=ts"
export * from "./LiveCase.vue?vue&type=script&lang=ts"
import style0 from "./LiveCase.vue?vue&type=style&index=0&id=0de93ad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports